import ColorInput, { ColorInputProps } from "@components/ColorInput"
import { Control, Controller, FieldValues, Path } from "react-hook-form"

type PropertyFieldProps<TFieldValues extends FieldValues> = ColorInputProps & {
  control: Control<TFieldValues>
  name: Path<TFieldValues>
}
export const PropertyColorField = <TFieldValues extends FieldValues>({
  control,
  name,
  ...props
}: PropertyFieldProps<TFieldValues>) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <ColorInput
          size="small"
          fullWidth
          helperText={fieldState.error?.message}
          error={!!fieldState.error}
          InputLabelProps={{ shrink: true }}
          {...field}
          {...props}
          ref={field.ref}
        />
      )}
    />
  )
}
